import {surveytopbarRender} from "../templates/renders/surveytopbar";

/**
 *
 * @type {{template, created(), tagName: string}}
 */
const SurveyTopBar: any = {
    tagName: "survey-top-bar",
    initialize(options) {
        initComponent(options);
    },
    renderer: surveytopbarRender,
    created() {
        this.topBarEL = this.el.firstChild;
        this.overFlowEL = this.topBarEL.querySelector(".overflow-menu-items");
        this.overflowVisible = false;
        const bridge = this.$app.getBridge();

        if (bridge) {
            bridge.addDrag(this.topBarEL);
        }
    },
    onHoverClick(event) {
        if (this.overFlowEL) {
            this.overflowVisible = !this.overflowVisible;
            this.overFlowEL.classList.toggle("enter");
        }

        event.stopPropagation();
    },
    hideOverflow() {
        if (this.overflowVisible && this.overFlowEL && this.overFlowEL.classList.contains("enter")) {
            this.overFlowEL.classList.remove("enter");
            this.overflowVisible = false;
        }
    },
};

export default appInstance => {
    SurveyTopBar.$app = appInstance;
    return SurveyTopBar;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const appConfig = appInstance.getUIConfig();

    if (appConfig.topBarConfig) {
        const tpConfig = appConfig.topBarConfig;
        options.constants = {
            barStyle: tpConfig.topBarStyles,
            config: tpConfig.topBarSettings || {},
            topBarIconStyle: tpConfig.iconStyles,
            overFlowMenuStyle: tpConfig.overFlowMenuStyles,
        };
    }
};
